import SVGDocFile from 'visitor-ui-component-library-icons/icons/SVGDocFile';
import SVGPdfFile from 'visitor-ui-component-library-icons/icons/SVGPdfFile';
export const FILE_TYPE_ICONS = {
  'application/pdf': SVGPdfFile,
  // Word (.doc / .docx)
  'application/msword': SVGDocFile,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': SVGDocFile,
  // OpenDocument text (.odt)
  'application/vnd.oasis.opendocument.text': SVGDocFile
};

// Extension fallback for when the server returns type:'OTHER'.
// The extension field is always reliably set from the filename.
export const EXTENSION_ICONS = {
  pdf: SVGPdfFile,
  doc: SVGDocFile,
  docx: SVGDocFile,
  odt: SVGDocFile
};